import { api } from 'services';
import type {
  ChecklistTemplate,
  ChecklistTemplatePayload,
  ChecklistTemplatesListResponse,
} from 'contracts/ChecklistTemplate';

export function useChecklistTemplates() {
  const getChecklistTemplates = async (): Promise<ChecklistTemplatesListResponse> => {
    const { data } = await api.get('/checklists');
    return data;
  };

  const getChecklistTemplate = async (id: number | string): Promise<ChecklistTemplate> => {
    const { data } = await api.get(`/checklists/${id}`);
    return data;
  };

  const createChecklistTemplate = async (
    payload: ChecklistTemplatePayload
  ): Promise<ChecklistTemplate> => {
    const { data } = await api.post('/checklists', payload);
    return data;
  };

  const updateChecklistTemplate = async (
    id: number | string,
    payload: ChecklistTemplatePayload
  ): Promise<ChecklistTemplate> => {
    const { data } = await api.put(`/checklists/${id}`, payload);
    return data;
  };

  const deleteChecklistTemplate = async (id: number | string): Promise<void> => {
    await api.delete(`/checklists/${id}`);
  };

  return {
    getChecklistTemplates,
    getChecklistTemplate,
    createChecklistTemplate,
    updateChecklistTemplate,
    deleteChecklistTemplate,
  };
}
